// YouTube play glyph and the popup player shared by the slideshow and the Eco-System image.
export const PlayIcon = () => (
  <svg viewBox="0 0 68 48" width="68" height="48" aria-hidden="true"><path fill="#f00" d="M66.5 7.7a8.5 8.5 0 0 0-6-6C55.3.3 34 .3 34 .3s-21.3 0-26.5 1.4a8.5 8.5 0 0 0-6 6C.1 13 .1 24 .1 24s0 11 1.4 16.3a8.5 8.5 0 0 0 6 6C12.7 47.7 34 47.7 34 47.7s21.3 0 26.5-1.4a8.5 8.5 0 0 0 6-6C67.9 35 67.9 24 67.9 24s0-11-1.4-16.3z" /><path fill="#fff" d="M45 24 27 14v20z" /></svg>
)

// `video` is a YouTube id, or an array of ids played as a playlist; `portrait` uses a 9:16 frame.
export default function VideoModal({ video, portrait = false, onClose }) {
  const ids = [video].flat()
  return (
    // Native modal: Esc closes it via onClose; clicking the backdrop (the dialog itself) closes too.
    <dialog className={portrait ? 'video-modal portrait' : 'video-modal'} ref={(d) => d && !d.open && d.showModal()} onClose={onClose}
      onClick={(e) => { if (e.target === e.currentTarget) e.currentTarget.close() }}>
      <button className="video-modal-close" onClick={(e) => e.currentTarget.closest('dialog').close()} aria-label="Close video">×</button>
      <iframe referrerPolicy="strict-origin-when-cross-origin" src={`https://www.youtube-nocookie.com/embed/${ids[0]}?autoplay=1&rel=0${ids.length > 1 ? `&playlist=${ids.slice(1).join(',')}` : ''}`} title="Video"
        allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen />
    </dialog>
  )
}
